// import { CollapseTransition } from 'vue2-transitions';

export default {
  name: 'CollapseItem',
  inject: {
    animationDuration: {
      default: 250
    },
    multipleActive: {
      default: false
    },
    addItem: {
      default: () => {}
    },
    removeItem: {
      default: () => {}
    },
    deactivateAll: {
      default: () => {}
    }
  },
  props: {
    isArrow: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '',
      description: 'Collapse item title'
    },
    id: String
  },
  data() {
    return {
      active: true
    };
  },
  computed: {
    itemId() {
      return this.id || this.title;
    }
  },
  mounted() {
    this.addItem(this);
  },
  unmounted() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    this.removeItem(this);
  },
  methods: {
    activate() {
      let wasActive = this.active;
      if (!this.multipleActive) {
        this.deactivateAll();
      }
      this.active = !wasActive;
    }
  }
};